module.exports = __webpack_public_path__ + "img/twentyE.7dfc9875.jpg";